export const CROP_BACKGROUND_EVENTS = {
    /** 裁剪取消 */
    CROP_CANCEL: 'crop-background-cancel',
    /** 裁剪确认 */
    CROP_CONFIRM: 'crop-background-confirm',

    /** 裁剪打开 */
    CROP_OPEN: 'crop-background-open',
    /** 裁剪关闭 */
    CROP_CLOSE: 'crop-background-close',
};
